import { styled } from "styled-components";

import { BodyText } from "styles";

export const ImageWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.lightBorder};
  border-radius: 8px;
`;

export const PostTitle = styled(BodyText)`
  &:hover {
    color: ${({ theme }) => theme.colors.lightBlue};
  }
`;
